import { useMutation } from '@tanstack/react-query';
import { RestEndpoints } from "../../../../api/endpoints";
import getInstance from "../../../../utils/rest";
import { IGroupExistingDebitorData } from "../../../domain/group/group-existing-debitor-data";

const getGroupExistingDebitors = async (
  name: string,
  vatId: string | null,
  tradeRegisterNumber: string | null,
): Promise<IGroupExistingDebitorData> => {
  const { data } = await getInstance().get<IGroupExistingDebitorData>(RestEndpoints.GroupExistingDebitors, {
    params: {
      name,
      vatId: vatId ?? null,
      tradeRegisterNumber: tradeRegisterNumber ?? null,
    },
  });
  return data;
};

export const useGetGroupExistingDebitors = () => {
  return useMutation({

    mutationFn: ({
      name,
      vatId,
      tradeRegisterNumber,
    }: {
      name: string;
      vatId: string | null;
      tradeRegisterNumber: string | null;
    }) => getGroupExistingDebitors(name, vatId, tradeRegisterNumber),
  });
};
